import CustomIcon from 'components/CustomIcon';
import Text from 'components/Text';
import styled from 'styled-components/native';

export const Container = styled.View`
  background: ${props => props.theme.colors.grayscale.slot1};
  box-shadow: 0px 4px 30px rgba(87, 85, 85, 0.2);
  border-radius: 8px;
  padding: 24px;
  margin-bottom: 24px;
`;

export const CardTitle = styled.View`
  padding: 0 10px 16px;
  flex-direction: row;
  align-items: center;
`;

export const CardTitleText = styled(Text)`
  color: ${props => props.theme.colors.grayscale.slot6};
  font-family: ${props => props.theme.fonts.weight[500]};
  font-size: 14px;
`;

export const CardTitleIcon = styled(CustomIcon)`
  color: ${props => props.theme.colors.grayscale.slot6};
  margin-right: 8px;
`;
